<div class="contenedor-tabla">
    <mat-table
        class="ootts-tabla"
        #table
        [dataSource]="dataSource"
        matSort
        matSortActive="fecha"
        matSortDisableClear
        matSortDirection="desc"
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
                <!--    <mat-checkbox
                        (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="
                            selection.hasValue() && !isAllSelected()
                        "
                        [aria-label]="checkboxLabel()"
                    >
                    </mat-checkbox>-->
            </mat-header-cell>
            <mat-cell *matCellDef="let oott">
                <div
                    [hidden]="
                        oott.ordenCompra ||
                        oott.estado.id === config.oott.estados.anulada.id
                    "
                >
                    <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelect($event, oott)"
                        [checked]="selection.isSelected(oott)"
                        [aria-label]="checkboxLabel(oott)"
                    >
                    </mat-checkbox>
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="idOrdenTrabajo">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >OOTT</mat-header-cell
            >
            <mat-cell *matCellDef="let oott">
                <a [routerLink]="'/ordenes-de-trabajo/' + oott.idOrdenTrabajo">
                    <span class="cursor-pointer">
                        {{ oott.idOrdenTrabajo }}
                    </span>
                </a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fecha">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Fecha</mat-header-cell
            >
            <mat-cell *matCellDef="let oott">
                <p>
                    {{ oott.fecha | date: "dd-MM-yyyy HH:mm" }}
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pagoContratista">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Pago Contratista</mat-header-cell
            >
            <mat-cell *matCellDef="let oott">
                <p *ngIf="oott.trabajoPagado != null">
                    {{ oott.trabajoPagado?'Pagado':'Pendiente' }}
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cliente">
            <mat-header-cell *matHeaderCellDef>Cliente</mat-header-cell>
            <mat-cell *matCellDef="let oott">
                <p>{{ oott.sucursal.cliente.nombre }}</p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="rut">
            <mat-header-cell *matHeaderCellDef>Rut</mat-header-cell>
            <mat-cell *matCellDef="let oott">
                <p>
                    {{ oott.sucursal.cliente.rut }}
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="s.nombre">
            <mat-header-cell
                class="column-nombre"
                *matHeaderCellDef
                mat-sort-header
                >Sucursal</mat-header-cell
            >
            <mat-cell *matCellDef="let oott" class="column-nombre">
                {{ oott.sucursal.nombre }}, {{ oott.sucursal.direccion }}
                {{ oott.sucursal.comuna.nombre }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="valor">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Valor</mat-header-cell
            >
            <mat-cell *matCellDef="let oott">
                <p>UF {{ oott.valorUf }}</p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numeroticket">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Ticket</mat-header-cell
            >
            <mat-cell *matCellDef="let oott">
                <p>
                    <strong>{{ oott.ticket || "-" }} </strong>
                    <button
                        *ngIf="
                            _menuUsuarioSrvc.esEncargado() &&
                            oott.estado.id !== config.oott.estados.anulada.id
                        "
                        mat-icon-button
                        type="button"
                        color="accent"
                        (click)="editarNroTicket(oott)"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ordenCompra">
            <mat-header-cell *matHeaderCellDef>OOCC</mat-header-cell>
            <mat-cell *matCellDef="let oott">
                <!-- <a
                        color="primary"
                        [routerLink]="
                            '/ordenes-de-compra/' + oott.ordenCompra?.id
                        "
                    > -->
                <a [routerLink]="'/ordenes-de-compra/' + oott.ordenCompra?.id">
                    {{ oott.ordenCompra?.numero }}</a
                >

                <!-- </a> no tengo como llegar direco a una oocc, la unica forma seria seteando el filtro nroOOCC y hacerlo persistente como en los contratistas -->
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="estado">
            <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
            <mat-cell *matCellDef="let oott">
                <p>
                    <strong>{{ oott.estado.descripcion }}</strong>
                </p>
            </mat-cell>
        </ng-container>
        <mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>

        <!--<tr mat-row *matRowDef="let oott; columns: displayedColumns"></tr>-->

        <mat-row *matRowDef="let oott; columns: displayedColumns"> </mat-row>
    </mat-table>

    <mat-paginator
        #paginator
        [length]="resultsLength"
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 25, 100]"
    >
    </mat-paginator>
</div>
<p *ngIf="dataSource.data.length === 0">No hay OOTT por el momento</p>
<div
    fxLayout="column"
    fxLayoutAlign.lt-md="center center"
    fxLayoutAlign="end end"
    fxLayoutGap="30px"
>
    <button
        mat-raised-button
        color="accent"
        class="mt-16"
        [disabled]="(selection.isEmpty() || !oottMismoCliente)"
        (click)="asociarOOCC()"
    >
        Asociar OOCC
    </button>
</div>
